import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const EditInsurance = memo((props) => {
  const { init_hospital_insurance, removeHospitalInsurance } = props;
  const [currentEditHospitalInsurance, setCurrentEditHospitalInsurance] = useState(init_hospital_insurance);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentEditHospitalInsurance({
      ...currentEditHospitalInsurance,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicHospitalInsuranceUpdate = () => {
    if (!currentEditHospitalInsurance.hospital_id) {
      alert("※全項目が必須選択です。");
      return
    }

    var data = {
      hospital_insurance: {
        notes: currentEditHospitalInsurance.notes,
      },
      id: currentEditHospitalInsurance.id,
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/api/v1/hospital_insurances/${currentEditHospitalInsurance.id}`, data)
    .then(resp => {
      console.log(resp.data);
      notify("success", "HospitalInsurance successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      setCurrentEditHospitalInsurance({ 
        ...currentEditHospitalInsurance,
        notes: init_hospital_insurance.notes,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "HospitalInsurance updated Error!");
    })
  }

  const onClickDeleteSubmit = (id) => {
    const sure = window.confirm('Are you sure?');
    if (sure) {
      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.delete(`/api/v1/hospital_insurances/${id}`)
      .then(resp => {
        console.log(resp);
        removeHospitalInsurance(id);
        notify("success", "HospitalInsurance successfully deleted!");
      })
      .catch(e => {
        console.log(e.response);
        notify("error", "HospitalInsurance delete Error!");
      })
    }
  }

  return (
    <>
      <tr>
        <th scope="row" className="col">{currentEditHospitalInsurance.insurance_name}</th>
        <td className="col-6">
          <div className="input-group">
            <span className="input-group-text">メモ</span>
            <input type="text" name="notes" className="form-control" value={currentEditHospitalInsurance.notes} placeholder="メモを入力" onChange={onChangeData} />
          </div>
        </td>
        <td className="col-2">
          <button className="btn btn-success mr-1" onClick={onClinicHospitalInsuranceUpdate} disabled={(!currentEditHospitalInsurance.hospital_id)}>
            <i className="fa fa-share-square" />
          </button>
          <button className="btn btn-outline-danger" onClick={() => onClickDeleteSubmit(init_hospital_insurance.id)}>
            <i className="far fa-trash-alt" />
          </button>
        </td>
      </tr>
    </>
  );
});